import { render, staticRenderFns } from "./AddFishSales.vue?vue&type=template&id=4d076c75&"
import script from "./AddFishSales.vue?vue&type=script&lang=js&"
export * from "./AddFishSales.vue?vue&type=script&lang=js&"
import style0 from "./AddFishSales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports